import { SlotGameType1_2 } from "../SlotGameType1_2";
export class BurningFruits10_2 extends SlotGameType1_2{}